/* línkè · 星洲的猫数据层（2026-07-20）========================
   GET /api/cat：状态+碎碎念+「它的小日子」（含克克夜里的真实瞬间）
   POST /api/cat {action: pet|feed|name|note}：摸摸/喂鱼/取名字/捎句话给克克
   ============================================================== */

export async function loadCat() {
  const res = await fetch('/api/cat', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return res.json();
}

export async function touchCat(action, extra = {}) {
  const res = await fetch('/api/cat', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action, ...extra }),
  });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return res.json();
}
